/**
 * @description Копировать через поддельный DOM элемент ввода.
 * @param {Document} documentElement Документ.
 * @returns {(function(text: string): (Promise<void>))}
 */
const copyThroughFakeTextarea = (documentElement) => {
  const fakeElement = documentElement.createElement('textarea');
  fakeElement.style.position = 'fixed';
  return (text) => {
    fakeElement.value = text;
    documentElement.body.appendChild(fakeElement);
    fakeElement.focus();
    fakeElement.select();
    try {
      return documentElement.execCommand('copy')
        ? Promise.resolve()
        : Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      documentElement.body.removeChild(fakeElement);
    }
  };
};

export default {
  methods: {
    /**
     * @description Отправить текст в буфер обмена.
     * @param {string} text Текст.
     * @returns {Promise<void>}
     */
    toClipboard(text) {
      if ('clipboard' in window.navigator) {
        return window.navigator.clipboard.writeText(text);
      }
      return copyThroughFakeTextarea(window.document)(text);
    },
  },
};
